import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import MoreMenuContent from './MoreMenuContent';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import MoreMenuMobileDropdown from './MoreMenuMobileDropdown';
import DesktopShareModal from '../../../SharePopup/DesktopSharePopup/DesktopShareModal';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import AddToGroupPopover from '../../_partials/AddToGroupPopup';
import PositionOnlyPopperPopover from '@wix/da-ds/pkg/popper/presets/PositionOnlyPopperPopover';
import { usePopover } from '../../../Popovers/redux/hooks';
import { PopoverType } from '../../../Popovers/redux/types';
import { ActionBarContext } from '../../ActionBarContext';
import { NotificationType } from '../../../Notifications';
import { useIsAddToGroupInMoreMenu } from './hooks';
import s from './MoreButton.scss';
export const MoreButton = ({ deviation  })=>{
    const { t  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const [sharePopupVisible, setSharePopupVisible] = useState(false);
    const actionBarType = useContext(ActionBarContext);
    const isAddToGroupInMoreMenu = useIsAddToGroupInMoreMenu(deviation);
    const { popover: addToGroupPopover , pushPopover: pushAddToGroupPopover , removePopover: removeAddToGroupPopover  } = usePopover(actionBarType === 'primary' ? PopoverType.ADD_TO_GROUP_PRIMARY : PopoverType.ADD_TO_GROUP_SECONDARY);
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(BiButton, {
            className: s['mobile-button']
        }, /*#__PURE__*/ React.createElement(ActionBarIcon, {
            icon: EllipsisIcon
        }), /*#__PURE__*/ React.createElement(MoreMenuMobileDropdown, {
            deviation: deviation
        }));
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, sharePopupVisible && /*#__PURE__*/ React.createElement(DesktopShareModal, {
        onRequestClose: ()=>setSharePopupVisible(false),
        deviation: deviation
    }), isAddToGroupInMoreMenu && /*#__PURE__*/ React.createElement(PositionOnlyPopperPopover, {
        popoverContent: /*#__PURE__*/ React.createElement(AddToGroupPopover, {
            actionbarType: actionBarType,
            deviation: deviation,
            onClose: removeAddToGroupPopover
        }),
        isVisible: addToGroupPopover.isOpen,
        placement: "bottom",
        onClickOutside: removeAddToGroupPopover
    }), /*#__PURE__*/ React.createElement(ActionBarItemWrapper, {
        allowMobilePopover: true,
        placement: isMobile ? 'top-end' : undefined,
        renderPopover: ({ closeTooltip  })=>/*#__PURE__*/ React.createElement(MoreMenuContent, {
                deviation: deviation,
                closeTooltip: closeTooltip,
                showDesktopDeviationSharePopup: ()=>setSharePopupVisible(true),
                showAddToGroupPopup: isAddToGroupInMoreMenu ? pushAddToGroupPopover : undefined
            }),
        notificationTypes: isAddToGroupInMoreMenu ? [
            NotificationType.AddToGroup
        ] : undefined,
        tooltip: t('actionbar.more.tooltip'),
        openBiData: {
            evid: BiEventType.MORE_MENU_CLICK,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
            sectionname: 'deviation'
        }
    }, /*#__PURE__*/ React.createElement(ActionBarToggleButton, {
        icon: EllipsisIcon
    })));
};
MoreButton.displayName = 'MoreButton';
export default MoreButton;
